import { useApp, useResponsive, useT } from "@/Hooks";
import CustomerCenterUserCreateOrEditPage, {
  CustomerCenterUserCreateOrEditPageForm,
  CustomerCenterUserCreateOrEditPageProps,
  CustomerCenterUserCreateOrEditPageResult,
} from "./CreateOrEdit/CustomerCenterUserCreateOrEditPage";

function useCustomerCenterUserModal() {
  const t = useT();
  const { modal } = useApp();
  const { isMobile } = useResponsive();
  const showCreateOrEdit = (
    props?: Omit<CustomerCenterUserCreateOrEditPageProps, "callback">,
  ) => {
    return new Promise<CustomerCenterUserCreateOrEditPageResult | undefined>(
      (resolve) => {
        const m = modal.info({
          icon: null,
          title: props?.values?.Id
            ? t("common.action.edit", undefined, "Edit")
            : t("common.action.create", undefined, "Create"),
          footer: [],
          closable: true,
          centered: true,
          width: isMobile ? "100vw" : "40vw",
          onCancel: () => resolve(undefined),
          content: (
            <CustomerCenterUserCreateOrEditPage
              {...props}
              callback={(result) => {
                m.destroy();
                resolve(result);
              }}
            />
          ),
        });
      },
    );
  };
  return {
    showCreate: async (
      values?: Partial<CustomerCenterUserCreateOrEditPageForm>,
    ) => showCreateOrEdit({ values }),
    showEdit: async (id: number) => showCreateOrEdit({ values: { Id: id } }),
  };
}
export default useCustomerCenterUserModal;
